import axios from 'axios';

export const getDomains = async (source) => {
   const response = await axios.get('/api/gpp/domains?pagesize=500');
   return response.data._embedded;
}

export const getTaskTypesForDomain = async (domainId, source) => {
   const response = await axios.get(`/api/gpp/domains/${domainId}/tasktypes?pagesize=500`);
   return response.data._embedded;
}

export const getgetTaskTypeMotivationForDomain = async (domainId, tasktypeId, source) => {
   const response = await axios.get(`/api/gpp/domains/${domainId}/tasktypes/${tasktypeId}/suggestedmotivations?pagesize=500`);
   return response.data._embedded;
}

export const getDomainMembersForDomain = async (domainId, source) => {
   const response = await axios.get(`/api/gpp/domains/${domainId}/domainmembers?pagesize=1000`);
   return response.data._embedded;
}

export const getWorkgroups = async (source) => {
   const response = await axios.get('/api/gpp/workgroups?pagesize=500', {
      cancelToken: source?.token
   });
return response.data._embedded;
}